import * as actionTypes from 'constants/ActionTypes';

const annotations = (state = { headers: {}, items: [], isLoaded: false }, action) => {
    switch (action.type) {
        case actionTypes.REMOVE_ANNOTATIONS: {
            return {
                ...state,
                items: [],
                headers: {},
            };
        }
        case actionTypes.POST_ANNOTATIONS.REQUEST:
            return {
                ...state,
                items: [],
                headers: {},
                isLoaded: false,
            };
        case actionTypes.POST_ANNOTATIONS.SUCCESS:
            const items = action.data.map((item) => {
                return {
                    ...item,
                    styles: {
                        background: '',
                    }
                }
            });

            return {
                ...state,
                items,
                headers: action.headers,
                isLoaded: true,
            };
        case actionTypes.POST_ANNOTATIONS.FAILURE:
            return {
                ...state,
                isLoaded: true,
                headers: {},
            };

        default:
            return state;
    }
};

export default annotations;



// WEBPACK FOOTER //
// ./app/reducers/annotations.js